import React from "react";
import CIcon from "@coreui/icons-react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faBiking,
  faCheckSquare,
  faClipboardCheck,
  faCogs,
  faHamburger,
  faListUl,
  faStore,
  faTachometerAlt,
  faUserFriends,
  faUserTie,
  faBuilding,
  faPercent,
  faMoneyBill,
  faCoins,
  faRupeeSign,
  faWindowClose,
  faHandHoldingUsd,
  faTasks,
  faShoppingBasket,
  faFish,
  faUtensils,
  faStoreAlt,
  faUsers,
  faFile,
} from "@fortawesome/free-solid-svg-icons";

const admin_nav = [
  {
    _tag: "CSidebarNavItem",
    name: "Dashboard",
    to: "/dashboard",
    icon: (
      <FontAwesomeIcon icon={faTachometerAlt} className="c-sidebar-nav-icon" />
    ),
  },
  {
    _tag: "CSidebarNavItem",
    name: "Branches",
    to: "/branches",
    icon: <FontAwesomeIcon icon={faBuilding} className="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Restaurants",
    to: "/stores",
    icon: <FontAwesomeIcon icon={faUtensils} className="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Grocery Stores",
    to: "/grocery",
    icon: <FontAwesomeIcon icon={faStoreAlt} className="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Meat Stores",
    to: "/meat",
    icon: <FontAwesomeIcon icon={faFish} className="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Orders",
    to: "/orders",
    icon: <FontAwesomeIcon icon={faListUl} className="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Customers",
    to: "/customer",
    icon: <FontAwesomeIcon icon={faUsers} className="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Summary",
    to: "/summary",
    icon: <FontAwesomeIcon icon={faFile} className="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Settings",
    to: "/settings",
    icon: <FontAwesomeIcon icon={faCogs} className="c-sidebar-nav-icon" />,
  },
];

const branch_nav = [
  {
    _tag: "CSidebarNavItem",
    name: "Dashboard",
    to: "/branchDashboard",
    icon: (
      <FontAwesomeIcon icon={faTachometerAlt} className="c-sidebar-nav-icon" />
    ),
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Restaurants",

    icon: <FontAwesomeIcon icon={faUtensils} className="c-sidebar-nav-icon" />,
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Restaurants List",
        to: "/branchStores",
        icon: (
          <FontAwesomeIcon
            style={{ paddingLeft: "25px" }}
            icon={faStore}
            className="c-sidebar-nav-icon"
          />
        ),
      },

      {
        _tag: "CSidebarNavItem",
        name: "Products",
        to: "/products",
        icon: (
          <FontAwesomeIcon
            style={{ paddingLeft: "25px" }}
            icon={faHamburger}
            className="c-sidebar-nav-icon"
          />
        ),
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Grocery",

    icon: (
      <FontAwesomeIcon icon={faShoppingBasket} className="c-sidebar-nav-icon" />
    ),
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Grocery Stores",
        to: "/branchGroceryStores",
        icon: (
          <FontAwesomeIcon
            style={{ paddingLeft: "25px" }}
            icon={faStore}
            className="c-sidebar-nav-icon"
          />
        ),
      },

      {
        _tag: "CSidebarNavItem",
        name: "Grocery Products",
        to: "/grocery-products",
        icon: (
          <FontAwesomeIcon
            style={{ paddingLeft: "25px" }}
            icon={faHamburger}
            className="c-sidebar-nav-icon"
          />
        ),
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Meat",

    icon: <FontAwesomeIcon icon={faFish} className="c-sidebar-nav-icon" />,
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Meat Stores",
        to: "/BranchMeatStores",
        icon: (
          <FontAwesomeIcon
            icon={faStore}
            className="c-sidebar-nav-icon"
            style={{ paddingLeft: "25px" }}
          />
        ),
      },

      {
        _tag: "CSidebarNavItem",
        name: "Meat Products",
        to: "/meat-products",
        icon: (
          <FontAwesomeIcon
            icon={faHamburger}
            className="c-sidebar-nav-icon"
            style={{ paddingLeft: "25px" }}
          />
        ),
      },
    ],
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Orders",

    icon: <FontAwesomeIcon icon={faTasks} className="c-sidebar-nav-icon" />,
    _children: [
      // {
      //   _tag: "CSidebarNavItem",
      //   name: "Todays Orders",
      //   to: "/branchOrders",
      //   icon: (
      //     <FontAwesomeIcon icon={faListUl} className="c-sidebar-nav-icon" />
      //   ),
      // },
      {
        _tag: "CSidebarNavItem",
        name: "Completed Orders",
        to: "/completedOrders",
        icon: (
          <FontAwesomeIcon
            icon={faCheckSquare}
            className="c-sidebar-nav-icon"
          />
        ),
      },
      {
        _tag: "CSidebarNavItem",
        name: "Cancelled Orders",
        to: "/cancelledOrders",
        icon: (
          <FontAwesomeIcon
            icon={faWindowClose}
            className="c-sidebar-nav-icon"
          />
        ),
      },
    ],
  },
  {
    _tag: "CSidebarNavItem",
    name: "Delivery Boys",
    to: "/delivery",
    icon: <FontAwesomeIcon icon={faBiking} className="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Executives",
    to: "/executives",
    icon: <FontAwesomeIcon icon={faUserTie} className="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Customers",
    to: "/customers",
    icon: (
      <FontAwesomeIcon icon={faUserFriends} className="c-sidebar-nav-icon" />
    ),
  },
  {
    _tag: "CSidebarNavDropdown",
    name: "Settlement",

    icon: <FontAwesomeIcon icon={faCoins} className="c-sidebar-nav-icon" />,
    _children: [
      {
        _tag: "CSidebarNavItem",
        name: "Delivery Settlement",
        to: "/dailysettle",
        icon: (
          <FontAwesomeIcon icon={faMoneyBill} className="c-sidebar-nav-icon" />
        ),
      },
      {
        _tag: "CSidebarNavItem",
        name: "Accounts",
        to: "/restaurantsettle",
        icon: (
          <FontAwesomeIcon icon={faRupeeSign} className="c-sidebar-nav-icon" />
        ),
      },
    ],
  },
  {
    _tag: "CSidebarNavItem",
    name: "Settings",
    to: "/branchSettings",
    icon: <FontAwesomeIcon icon={faCogs} className="c-sidebar-nav-icon" />,
  },
];

const delivery_nav = [
  {
    _tag: "CSidebarNavItem",
    name: "Orders",
    to: "/assignOrders",
    icon: <FontAwesomeIcon icon={faListUl} className="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Todays Orders",
    to: "/todaysOrders",
    icon: (
      <FontAwesomeIcon icon={faClipboardCheck} className="c-sidebar-nav-icon" />
    ),
  },
];

const offline_nav = [
  {
    _tag: "CSidebarNavItem",
    name: " Create Orders",
    to: "/CreateOrders",
    icon: (
      <FontAwesomeIcon icon={faClipboardCheck} className="c-sidebar-nav-icon" />
    ),
  },
  {
    _tag: "CSidebarNavItem",
    name: "Direct Order",
    to: "/directorder",
    icon: <FontAwesomeIcon icon={faBiking} className="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavItem",
    name: "Todays Orders",
    to: "/todaysOrders",
    icon: (
      <FontAwesomeIcon icon={faClipboardCheck} className="c-sidebar-nav-icon" />
    ),
  },
];

const order_nav = [
  {
    _tag: "CSidebarNavItem",
    name: " Current Orders",
    to: "/currentOrders",
    icon: <FontAwesomeIcon icon={faListUl} className="c-sidebar-nav-icon" />,
  },
  {
    _tag: "CSidebarNavItem",
    name: " Todays Orders",
    to: "/todaysOrders",
    icon: (
      <FontAwesomeIcon icon={faClipboardCheck} className="c-sidebar-nav-icon" />
    ),
  },
];

export { admin_nav, branch_nav, delivery_nav, offline_nav, order_nav };
